export default "__VITE_ASSET__CSnDT_M3__"